import * as jsxRuntime from "/home/runner/work/louisebot-chatbot-interface/louisebot-chatbot-interface/front-end/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment